<div class="card">
    <ul class="pt-1 nav nav-tabs" style="border-bottom: 1px solid #eee; margin-bottom: 24px;">
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-apercue'] : ['/bibliotheque-clients/actif']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Aperçu
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-relevéDuCompte'] : ['/bibliotheque-clients/actif']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Relevé du compte
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-document'] : ['/bibliotheque-clients/actif']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: false }"
            href="javascript:void(0)"
            >
            Document
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-paimentNonAffectés'] : ['/bibliotheque-clients/actif']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Paiement non affectés
            </a>
        </li>
    </ul>
    <router-outlet></router-outlet>
</div>
